module.exports = __webpack_public_path__ + "img/1508614133.0ad84dd0.jpg";